import { render, staticRenderFns } from "./departmentEdit.vue?vue&type=template&id=0bf51a76&scoped=true&lang=html&"
import script from "./departmentEdit.vue?vue&type=script&lang=js&"
export * from "./departmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./departmentEdit.vue?vue&type=style&index=0&id=0bf51a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf51a76",
  null
  
)

export default component.exports